import React from 'react'
import { Segment } from 'semantic-ui-react'

const SegmentExampleRaised = () => (
  <Segment raised>Member info not added</Segment>
)

export default SegmentExampleRaised